const isBrowser = typeof window !== 'undefined'

const safeJsonParse = (raw) => {
  if (!raw || typeof raw !== 'string') return null
  try {
    return JSON.parse(raw)
  } catch (error) {
    return null
  }
}

export const readSessionJson = (key) => {
  if (!isBrowser) return null
  try {
    return safeJsonParse(window.sessionStorage.getItem(key))
  } catch (error) {
    return null
  }
}

export const writeSessionJson = (key, value) => {
  if (!isBrowser) return
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    // Ignore storage quota/security errors.
  }
}

export const removeSessionKey = (key) => {
  if (!isBrowser) return
  try {
    window.sessionStorage.removeItem(key)
  } catch (error) {
    // Ignore storage quota/security errors.
  }
}

